/* Panteer Produktseiten v2 – Kaufbereich, Module, Upload */
(function () {
  'use strict';
  if (window.__ppInit) return;
  window.__ppInit = true;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function initMain(root) {
    if (root.__ppMain) return;
    root.__ppMain = true;
    var fam = root.getAttribute('data-family');
    var jsonEl = $('[data-pp-variants-json]', root);
    var variants = [];
    try { variants = JSON.parse(jsonEl ? jsonEl.textContent : '[]'); } catch (e) { variants = []; }
    var form = $('form[action*="/cart/add"]', root);
    var idInput = form ? $('.product-variant-id', form) : null;
    var cta = $('[data-pp-cta]', root);
    var ctaTxt = cta ? $('span', cta) : null;
    var priceEl = $('[data-pp-price]', root);
    var unitEl = $('[data-pp-unit]', root);
    var stockEls = $$('[data-pp-stock]', root);
    var stageImg = $('[data-pp-stage-img]', root);
    var thumbs = $$('.thumbs button', root);
    var qty = $('[data-pp-qty]', root);
    var sticky = $('[data-pp-sticky]', root);
    var variantWrap = $('[data-pp-variants]', root);
    var ctaLabel = cta ? cta.getAttribute('data-label') : '';

    function showMedia(btn) {
      if (!btn || !stageImg) return;
      stageImg.src = btn.getAttribute('data-src');
      stageImg.alt = btn.getAttribute('data-alt') || '';
      stageImg.removeAttribute('srcset');
      thumbs.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { showMedia(b); }); });

    var minus = $('[data-pp-minus]', root), plus = $('[data-pp-plus]', root);
    if (qty) {
      qty.addEventListener('change', function () { var v = parseInt(qty.value, 10); qty.value = (!v || v < 1) ? 1 : v; });
      if (minus) minus.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { qty.value = (parseInt(qty.value, 10) || 1) + 1; });
    }

    var selected = [];
    function readSelected() {
      selected = $$('.vopt', root).map(function (o) {
        var on = $('[aria-checked="true"]', o);
        return on ? on.getAttribute('data-value') : null;
      });
    }
    function findVariant() {
      for (var i = 0; i < variants.length; i++) {
        var ok = true;
        for (var j = 0; j < selected.length; j++) { if (variants[i].options[j] !== selected[j]) { ok = false; break; } }
        if (ok) return variants[i];
      }
      return null;
    }
    stockEls.forEach(function (el) {
      var t = $('[data-pp-stock-txt]', el);
      if (t && el.classList.contains('stock')) el.__in = t.textContent.indexOf('nicht verf') > -1 ? 'Auf Lager' : t.textContent;
    });
    function applyVariant(v) {
      if (!v) return;
      if (idInput) { idInput.value = v.id; if (v.available) idInput.removeAttribute('disabled'); else idInput.setAttribute('disabled', 'disabled'); }
      if (priceEl) {
        priceEl.textContent = v.price;
        if (v.cmp) { var s = document.createElement('s'); s.textContent = v.cmp; priceEl.appendChild(s); }
      }
      if (unitEl) unitEl.textContent = v.unit || '';
      stockEls.forEach(function (el) {
        var txt = $('[data-pp-stock-txt]', el);
        if (el.classList.contains('stock')) {
          el.classList.toggle('out', !v.available);
          if (txt) txt.textContent = v.available ? (el.__in || 'Auf Lager') : 'Derzeit nicht verfügbar';
        }
      });
      if (cta) {
        if (v.available) cta.removeAttribute('disabled'); else cta.setAttribute('disabled', 'disabled');
        if (ctaTxt) ctaTxt.textContent = v.available ? ctaLabel : 'Ausverkauft';
      }
      $$('[data-pp-vsel]', root).forEach(function (el, i) { if (selected[i] != null) el.textContent = selected[i]; });
      if (sticky) {
        var sv = $('[data-pp-sticky-var]', sticky), sp = $('[data-pp-sticky-price]', sticky), sb = $('[data-pp-sticky-btn]', sticky);
        if (sv) sv.textContent = (v.title && v.title !== 'Default Title') ? v.title : '';
        if (sp) sp.textContent = v.short;
        if (sb) sb.disabled = !v.available;
      }
      if (v.media) {
        var t = thumbs.filter(function (b) { return String(b.getAttribute('data-media-id')) === String(v.media); })[0];
        if (t) showMedia(t);
      }
      try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
    }

    if (variantWrap) {
      $$('.vars', variantWrap).forEach(function (grp) {
        function pick(el) {
          $$('[role=radio]', grp).forEach(function (x) { x.setAttribute('aria-checked', 'false'); x.classList.remove('on'); });
          el.setAttribute('aria-checked', 'true'); el.classList.add('on');
          readSelected(); applyVariant(findVariant());
        }
        grp.addEventListener('click', function (e) { var el = e.target.closest('[role=radio]'); if (el) pick(el); });
        grp.addEventListener('keydown', function (e) {
          var el = e.target.closest('[role=radio]'); if (!el) return;
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(el); return; }
          var all = $$('[role=radio]', grp), i = all.indexOf(el);
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); var n = all[(i + 1) % all.length]; n.focus(); pick(n); }
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); var p = all[(i - 1 + all.length) % all.length]; p.focus(); pick(p); }
        });
      });
      readSelected();
    }

    if (sticky && cta && 'IntersectionObserver' in window) {
      var sb2 = $('[data-pp-sticky-btn]', sticky);
      var io = new IntersectionObserver(function (en) {
        var e = en[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (sb2) sb2.tabIndex = on ? 0 : -1;
      }, { threshold: 0 });
      io.observe(cta);
      if (sb2) sb2.addEventListener('click', function () { if (!sb2.disabled) cta.click(); });
    }

    var up = $('[data-pp-upload]', root);
    if (up && fam === 'rodentizid') initUpload(root, up, form);
  }

  function initUpload(root, up, form) {
    var ENDPOINT = up.getAttribute('data-endpoint');
    var MAX_FILES = parseInt(up.getAttribute('data-max-files'), 10) || 5;
    var MAX_BYTES = (parseInt(up.getAttribute('data-max-mb'), 10) || 5) * 1048576;
    var MSG = up.getAttribute('data-msg') || 'Bitte laden Sie zuerst Ihren Sachkundenachweis und Ihren Gewerbenachweis hoch.';
    var KEY = 'sku-files-' + up.getAttribute('data-product-id');
    var EXT = /\.(pdf|jpe?g|png)$/i, MIME = /^(application\/pdf|image\/jpeg|image\/png)$/i;
    var list = $('[data-pp-uplist]', up), errEl = $('[data-pp-uperr]', up), input = $('[data-pp-upin]', up), btn = $('[data-pp-upbtn]', up);
    var cbs = $$('[data-pp-cb]', root), cbErr = $('[data-pp-cberr]', root), cbox = $('[data-pp-cbox]', root);
    var files = [], pending = 0, uploading = [];

    function err(m) { errEl.textContent = m || ''; }
    function save() { try { sessionStorage.setItem(KEY, JSON.stringify(files)); } catch (e) {} }
    try { var raw = sessionStorage.getItem(KEY); if (raw) { var a = JSON.parse(raw); if (Array.isArray(a)) files = a.filter(function (f) { return f && f.id && f.sig && f.name; }).slice(0, MAX_FILES); } } catch (e) {}

    function hidden(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; i.setAttribute('data-sku', '1'); form.appendChild(i); }
    function sync() {
      if (form) {
        $$('input[data-sku]', form).forEach(function (n) { n.remove(); });
        if (files.length) {
          hidden('properties[Sachkundenachweis]', files.map(function (f) { return f.name; }).join(', '));
          hidden('properties[_sachkunde_files]', files.map(function (f) { return f.id + '.' + f.sig; }).join(','));
        }
      }
      $$('.rq', up).forEach(function (r, i) { r.classList.toggle('ok', files.length > i); });
      document.documentElement.classList.toggle('sku-ok', files.length > 0 && pending === 0);
    }
    function render() {
      list.textContent = '';
      files.forEach(function (f, idx) {
        var li = document.createElement('li');
        var n = document.createElement('span'); n.textContent = f.name + ' · ✓ hochgeladen';
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', f.name + ' entfernen'); b.textContent = '×';
        b.addEventListener('click', function () { files.splice(idx, 1); save(); err(''); render(); sync(); });
        li.appendChild(n); li.appendChild(b); list.appendChild(li);
      });
      uploading.forEach(function (u) { list.appendChild(u.el); });
    }
    function validate(f) {
      if (!EXT.test(f.name) || (f.type && !MIME.test(f.type))) return '„' + f.name + '“: Nur PDF, JPG oder PNG sind erlaubt.';
      if (f.size > MAX_BYTES) return '„' + f.name + '“ ist größer als ' + (MAX_BYTES / 1048576) + ' MB.';
      if (f.size === 0) return '„' + f.name + '“ ist leer.';
      return '';
    }
    function uploadOne(file) {
      var li = document.createElement('li'), n = document.createElement('span'), bar = document.createElement('span'), fill = document.createElement('i'), st = document.createElement('span');
      n.textContent = file.name; bar.className = 'bar2'; bar.appendChild(fill); st.textContent = '0 %';
      li.appendChild(n); li.appendChild(bar); li.appendChild(st);
      var entry = { el: li }; uploading.push(entry); pending++; render(); sync();
      function done() { uploading.splice(uploading.indexOf(entry), 1); pending--; save(); render(); sync(); }
      var x = new XMLHttpRequest();
      x.open('POST', ENDPOINT, true);
      x.upload.onprogress = function (e) { if (e.lengthComputable) { var p = Math.round(e.loaded / e.total * 100); fill.style.width = p + '%'; st.textContent = p + ' %'; } };
      x.onload = function () {
        var r = null; try { r = JSON.parse(x.responseText); } catch (e) {}
        if (x.status >= 200 && x.status < 300 && r && r.ok && r.id && r.sig) files.push({ name: file.name, id: r.id, sig: r.sig });
        else err('„' + file.name + '“ konnte nicht hochgeladen werden' + (r && r.error ? ': ' + r.error : '. Bitte erneut versuchen.'));
        done();
      };
      x.onerror = x.ontimeout = function () { err('„' + file.name + '“: Verbindung fehlgeschlagen. Bitte erneut versuchen.'); done(); };
      x.timeout = 120000;
      var fd = new FormData(); fd.append('file', file, file.name); x.send(fd);
    }
    function add(fl) {
      err('');
      var arr = Array.prototype.slice.call(fl), free = MAX_FILES - files.length - pending;
      if (arr.length > free) { err('Es sind maximal ' + MAX_FILES + ' Dateien möglich.'); arr = arr.slice(0, Math.max(free, 0)); }
      arr.forEach(function (f) { var m = validate(f); if (m) { err(m); return; } uploadOne(f); });
    }
    input.addEventListener('change', function () { add(input.files); input.value = ''; });
    btn.addEventListener('click', function () { input.click(); });
    ['dragenter', 'dragover'].forEach(function (ev) { up.addEventListener(ev, function (e) { e.preventDefault(); up.classList.add('is-drag'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { up.addEventListener(ev, function (e) { e.preventDefault(); up.classList.remove('is-drag'); }); });
    up.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) add(e.dataTransfer.files); });

    function guard(e) {
      if (!form) return;
      if (e.type === 'submit') { if (e.target !== form) return; }
      else { var t = e.target && e.target.closest ? e.target.closest('[data-pp-cta],[data-pp-sticky-btn]') : null; if (!t) return; }
      var allCb = cbs.every(function (c) { return c.checked; });
      if (files.length > 0 && pending === 0 && allCb) { sync(); if (cbErr) cbErr.textContent = ''; return; }
      e.preventDefault(); e.stopImmediatePropagation();
      if (!(files.length > 0 && pending === 0)) {
        err(pending > 0 ? 'Bitte warten Sie, bis der Upload abgeschlossen ist.' : MSG);
        up.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else if (!allCb) {
        if (cbErr) cbErr.textContent = 'Bitte bestätigen Sie alle Punkte, bevor Sie in den Warenkorb legen.';
        if (cbox) cbox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
    document.addEventListener('click', guard, true);
    document.addEventListener('submit', guard, true);
    cbs.forEach(function (c) { c.addEventListener('change', function () { if (cbErr && cbs.every(function (x) { return x.checked; })) cbErr.textContent = ''; }); });
    render(); sync(); setTimeout(sync, 500); setTimeout(sync, 2000);
  }

  function initCarousel(car) {
    if (car.__ppCar) return; car.__ppCar = true;
    var track = $('.track', car); if (!track) return;
    var kids = Array.prototype.slice.call(track.children);
    if (kids.length < 2) return;
    var prev = document.createElement('button'), next = document.createElement('button'), dots = document.createElement('div');
    prev.type = next.type = 'button'; prev.className = 'nav prev'; next.className = 'nav next';
    prev.setAttribute('aria-label', 'Zurück'); next.setAttribute('aria-label', 'Weiter');
    prev.textContent = '‹'; next.textContent = '›'; dots.className = 'dots';
    kids.forEach(function (k, i) { var d = document.createElement('i'); d.addEventListener('click', function () { track.scrollTo({ left: kids[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); }); dots.appendChild(d); });
    car.insertBefore(prev, track); car.insertBefore(next, track); car.appendChild(dots);
    function upd() {
      var max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 2; next.disabled = track.scrollLeft >= max - 2;
      var idx = 0, best = 1e9;
      kids.forEach(function (k, i) { var dd = Math.abs((k.offsetLeft - track.offsetLeft) - track.scrollLeft); if (dd < best) { best = dd; idx = i; } });
      $$('i', dots).forEach(function (d, i) { d.classList.toggle('on', i === idx); });
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -(kids[0].getBoundingClientRect().width + 14), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: (kids[0].getBoundingClientRect().width + 14), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd); upd();
  }

  function initTabs(box) {
    if (box.__ppTabs) return; box.__ppTabs = true;
    var tabs = $$('.ptabs button', box), picks = $$('.pick', box);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-pick');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        picks.forEach(function (p) { p.hidden = p.getAttribute('data-pick') !== id; });
      });
    });
  }
  function initCmp(box) {
    if (box.__ppCmp) return; box.__ppCmp = true;
    $$('[data-cmp]', box).forEach(function (b) {
      b.addEventListener('click', function () {
        box.setAttribute('data-f', b.getAttribute('data-cmp'));
        $$('[data-cmp]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      });
    });
  }
  function initFaq(box) {
    if (box.__ppFaq) return; box.__ppFaq = true;
    var items = $$('details.q', box), tabs = $$('.ftabs button', box);
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var f = t.getAttribute('data-f');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        items.forEach(function (d) { d.hidden = f !== 'all' && d.getAttribute('data-topic') !== f; });
      });
    });
  }
  function initClamp(box) {
    if (box.__ppClamp) return; box.__ppClamp = true;
    var b = $('[data-pp-more]', box);
    if (b) b.addEventListener('click', function () { var o = box.classList.toggle('open'); b.textContent = o ? 'Weniger anzeigen' : 'Weiterlesen'; b.setAttribute('aria-expanded', o ? 'true' : 'false'); });
  }

  function initAll() {
    $$('[data-pp-root]').forEach(initMain);
    $$('.pp .car').forEach(initCarousel);
    $$('.pp [data-pp-tabs]').forEach(initTabs);
    $$('.pp .cmpbox').forEach(initCmp);
    $$('.pp [data-pp-faq]').forEach(initFaq);
    $$('.pp [data-pp-clamp]').forEach(initClamp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
